

import React from 'react';
import ClassAssembly  from 'views/ClassAssembly2D';

const ClassAssemblyPage = () => {
    return <ClassAssembly />;
  };
  
  export default ClassAssemblyPage;